export default "__VITE_PUBLIC_ASSET__071139e8__"